import { FEATURE_FLAGS, Shop } from "@/types/v2";
import { useStore } from "@/stores/useStore";

export const useFeatures = (shop?: Shop) => {
  const features: { [x in FEATURE_FLAGS]: boolean } = Object.keys(
    FEATURE_FLAGS
  ).reduce(
    (acc, flag) => {
      acc[flag as FEATURE_FLAGS] =
        shop?.enabledFeatures[flag as keyof typeof shop.enabledFeatures] ??
        false;
      return acc;
    },
    {} as { [x in FEATURE_FLAGS]: boolean }
  );

  return { features };
};

export const useFeature = (feature: FEATURE_FLAGS): boolean => {
  const shop = useStore((state) => state.shop);
  const { features } = useFeatures(shop);
  return features[feature] ?? false;
};
